<div class="page-title-gradient mb-4">
    <div class="container">
        <div class="row align-items-center">
            <div class="col">
                <div class="vendor-info" (click)="companyInformation()">
                    <div class="logo">
                        <img [src]="companyData?.design?.logo?.icon?.url ? companyData?.design?.logo?.icon?.url : 'assets/images/nologo.png'">
                    </div>
                    <h1 class="vendor-name">{{translateHelper.localize(companyData?.name)}}</h1>
                </div>
            </div>
            <div class="col-md-auto">
                <div class="controls">
                    <small class="my-2">{{'didnt_find_what_you_are_looking_for'|translate}}</small>
                </div>
                <div class="controls">
                    <button eventCollector eventName="vendor_chat" [companyId]="companyData?._id"   (click)="openChat();" category="product_page" itemType="property" class="btn btn-primary btn-sm flex">
                        <div class="icon"><mat-icon [inline]="true">question_answer</mat-icon></div>
                        <div class="label">{{'communicate'|translate}}</div>
                    </button>
                    <a *ngIf="whatsapp" eventCollector [companyId]="companyData?._id" eventName="whatsapp" category="product_page" itemType="property" href="https://api.whatsapp.com/send?phone={{whatsapp.number}}" class="btn btn-primary btn-whatsapp btn-sm" target="_blank">
                        <div class="icon"><mat-icon [inline]="true">whatsapp</mat-icon></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>